import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase';
gsap.registerPlugin( ScrollTrigger, CustomEase );

( function( app ) {
  const COMPONENT = {
    init() {},
    finalize() {},

    animate() {
      // -----------------------------
      // GSAP fade/reveal animations
      // -----------------------------
      $( '.js-fade:not(.js-ignore), .js-reveal:not(.js-ignore), .js-fade-group' ).each( function() {
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 90%',
            scrub: 0.15,
            onEnter: () => $( this ).addClass( 'js-animated' ),
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) $( this ).addClass( 'js-animated' );
            },
          },
        } );

        if ( $( this ).hasClass( 'js-fade-group' ) ) {
          $( this ).children().each( ( i, child ) => {
            const delay = ( i + 1 ) / 10;
            child.style.setProperty( '--fade-group-delay', delay + 's' );
          } );
        }
      } );
    },

    onError() {
      document.querySelectorAll( '.js-fade' )?.forEach( ( el ) => el.classList.remove( 'js-fade' ) );
    },
  };

  app.registerComponent( 'animations', COMPONENT );
} )( app );
